import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppConfigService } from '../shared/services/app-config.service';
import { ConnectionService } from '../shared/services/connection.service';
import { Observable } from 'rxjs';
import {
  ChannelMappingData,
  Integration,
  sChannelMappingData,
} from '@product/shared/models/integration';
import { GenericOdataResponse } from '../shared/interfaces/odata-response';
import { ListPayload } from '@product/shared/models/ListPayload';
import { ListResponse } from '@app/shared/interfaces/list-response';
import { ObjectType } from '@product/shared/models/Enums.enum';
@Injectable({
  providedIn: 'root',
})
export class ChannelService {
  constructor(
    private http: HttpClient,
    private connectionService: ConnectionService
  ) {}
  getIntegrations(): Observable<GenericOdataResponse<Integration>> {
    return new Observable<GenericOdataResponse<Integration>>((obs) => {
      this.connectionService.get(
        `${AppConfigService.settings.dataApiUrl}Integration?expand=Channels`,
        (response) => {
          obs.next(response);
        }
      );
    });
  }

  syncProducts(
    data: ChannelMappingData[] | sChannelMappingData[]
  ): Observable<sChannelMappingData[]> {
    return this.http.post<sChannelMappingData[]>(
      `${AppConfigService.settings.apiUrl}CustomIntegration/sync-products`,
      data
    );
  }

  updateSyncData(datum: ChannelMappingData[] | sChannelMappingData[]) {
    return this.http.put(
      `${AppConfigService.settings.apiUrl}CustomIntegration/update-sync-data`,
      datum
    );
  }

  getChannelProducts(
    payload: ListPayload,
    channelId: number,
    integraitonId: number
  ): Observable<ListResponse<any>> {
    return this.http.post<ListResponse<any>>(
      `${AppConfigService.settings.apiUrl}CustomIntegration/channel-products/${channelId}/${integraitonId}`,
      payload
    );
  }

  deactivateMappingData(
    objectType: ObjectType,
    integrationId: number,
    channelId: number,
    ids: number[]
  ) {
    return this.http.put(
      `${AppConfigService.settings.apiUrl}CustomIntegration/deactivate-sync-data/${objectType}/${integrationId}/${channelId}`,
      ids
    );
  }

  getAllChannelsProducts(paylod:any,channelId: number, integrationId: number) {
  return this.http.post<any>(
    `${AppConfigService.settings.apiUrl}CustomProduct/select-all-channel-products?channelId=${channelId}&integrationId=${integrationId}`,
    {}
  );
}

}
